import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { globalData } from 'src/app/main/Models/global.model';
import { ApiService } from '../../custom-material/Services/api.service';
import { UserModel } from '../../main/Models';

@Component({
  selector: 'app-intro',
  templateUrl: './new2_intro.component.html',
  styleUrls: ['./intro.component.less']
})
export class IntroComponent implements OnInit {

  /*@Output()
  passIntro: EventEmitter<boolean> = new EventEmitter();*/

  selected: number;

  modules = ['audits', 'synthesis', 'management', 'incidents', 'stats'];
  icons = ['location_city', 'pie_chart', 'account_tree', 'sync_problem', 'show_chart']
  get user(): UserModel
  {
    return this.apiService.connectedUser;
  }

  constructor(private apiService: ApiService,
              private gd: globalData) {
                this.gd.headerTitle = null;
                this.gd.toollist = null;
                this.gd.showChooser = false;
               }

  ngOnInit(): void {}

  /*pass() {
  	this.passIntro.emit(true);
  }*/

  step;

  setStep(index: number) {
    this.step = index;
  }

}
